import { useEffect, useState } from 'react'
import { useValueBasedOnLanguage } from './useValueBasedOnLanguage'

const buildMedicareUrl = (prodUrlString: string) => {
  // These are defined within the function so that in testing we can simply swap env values
  const medicareEnv = process.env.REACT_APP_MEDICARE_ENV ?? 'www'
  const extendedMedicareEnv = `${medicareEnv}.`

  const prodUrl = new URL(prodUrlString)
  // This logic handles any 'es' subdomains
  if (medicareEnv === 'www') {
    return prodUrl.toString()
  } else {
    const isSpanishProdUrl = prodUrl.hostname.startsWith('es.')
    if (isSpanishProdUrl) {
      // Spanish prod urls do not have the 'www' so we add the subdomain onto the 'es.'
      return new URL(prodUrl.href.replace('es.', `es.${extendedMedicareEnv}`)).toString()
    } else {
      return new URL(prodUrl.href.replace('www.', extendedMedicareEnv)).toString()
    }
  }
}

/**
 * @param englishProdUrl
 * @param spanishProdUrl
 * @returns the environment specific url by transforming the production medicare urls
 */
export const useMedicareUrl = (
  englishProdUrl: string,
  spanishProdUrl: string
) => {
  const prodUrl = useValueBasedOnLanguage(englishProdUrl, spanishProdUrl)
  const [url, setUrl] = useState(buildMedicareUrl(prodUrl))

  useEffect(() => {
    setUrl(buildMedicareUrl(prodUrl))
  }, [setUrl, prodUrl])

  return url
}
